import { ArrayPath } from './ArrayPath'
import { getArrayPath } from './getArrayPath'

export const setByPath = (
  curr: Record<string, any> | Array<any>,
  path: string | ArrayPath,
  value: any,
  generative = true,
  insert = false
) => {
  path =
    typeof path === 'string'
      ? getArrayPath(path)
      : path == undefined
      ? []
      : path

  if (path.length === 0) {
    return value
  }

  const next =
    typeof path[0] === 'number'
      ? Array.isArray(curr)
        ? Object.is(path[0], -0)
          ? curr.length
          : path[0] < 0
          ? Math.max(curr.length + path[0], 0)
          : path[0]
        : curr
        ? path[0].toString()
        : 0
      : path[0]

  return generative || next in curr
    ? typeof next === 'number'
      ? new Array(
          Math.max(
            Array.isArray(curr)
              ? insert && path.length === 1 && next < curr.length
                ? curr.length + 1
                : curr.length
              : 1,
            next + 1
          )
        )
          .fill(undefined)
          .map((_, i) =>
            i === next
              ? setByPath(curr?.[i], path.slice(1), value, generative, insert)
              : insert && path.length === 1 && i > next
              ? curr?.[i - 1]
              : curr?.[i]
          )
      : {
          ...curr,
          [next]: setByPath(
            curr?.[next],
            path.slice(1),
            value,
            generative,
            insert
          ),
        }
    : curr
}
